import { Controller } from "@hotwired/stimulus";
import ahoy from "ahoy.js";

// Declarative click tracking:
//   <button data-controller="analytics"
//           data-action="analytics#track"
//           data-analytics-event-param="referral_started">
// Event names are static labels — never interpolate user data into them.
export default class extends Controller {
  track(event) {
    const name = event.params.event;
    if (name) ahoy.track(name);
  }
}
